import {
  differenceInWeeks,
  format,
  formatDistanceToNow,
  isToday,
  isTomorrow,
  isYesterday
} from 'date-fns'
import ltLocale from 'date-fns/locale/lt'

function getLocale(locale) {
  if (locale === 'lt') {
    return ltLocale
  }

  return undefined
}

export default {
  methods: {
    $getDateTime(date, locale = 'en') {
      return format(new Date(date), 'yyyy-MM-dd HH:mm', {
        locale: getLocale(locale)
      })
    },
    $getDateMonthFirst(date, locale = 'en') {
      return format(new Date(date), 'MMMM d, yyyy', {
        locale: getLocale(locale)
      })
    },
    $getDateYearMonth(date, locale = 'en') {
      return format(new Date(date), 'yyyy MMMM', {
        locale: getLocale(locale)
      })
    },
    $getDateYearMonthDay(date, locale = 'en') {
      return format(new Date(date), 'yyyy MM dd', {
        locale: getLocale(locale)
      })
    },
    $getDateAsTime(date) {
      return format(new Date(date), 'H:mm')
    },
    $getDateMonth(date, locale = 'en') {
      return format(new Date(date), 'MMMM', {
        locale: getLocale(locale)
      })
    },
    $getDateFromNow(date, locale = 'en') {
      return formatDistanceToNow(new Date(date), {
        addSuffix: true,
        locale: getLocale(locale)
      })
    },
    $getDateCalendar(date, locale = 'en') {
      const currentDate = new Date(date)

      const weekDiff = differenceInWeeks(new Date(), currentDate)

      if (locale === 'lt') {
        if (isToday(currentDate)) {
          return format(currentDate, 'HH:mm', {
            locale: getLocale(locale)
          })
        }

        if (isTomorrow(currentDate)) {
          return format(currentDate, "HH:mm '⋅ Rytoj'", {
            locale: getLocale(locale)
          })
        }

        if (isYesterday(currentDate)) {
          return format(currentDate, "HH:mm '⋅ Vakar'", {
            locale: getLocale(locale)
          })
        }

        if (weekDiff === 1 || weekDiff === -1) {
          return format(currentDate, "HH:mm '⋅' EEE", {
            locale: getLocale(locale)
          })
        }

        return format(currentDate, "HH:mm '⋅' MMM dd yyyy", {
          locale: getLocale(locale)
        })
      }

      if (isToday(currentDate)) {
        return format(currentDate, "'Today at' HH:mm", {
          locale: getLocale(locale)
        })
      }

      if (isTomorrow(currentDate)) {
        return format(currentDate, "'Tomorrow at' HH:mm", {
          locale: getLocale(locale)
        })
      }

      if (isYesterday(currentDate)) {
        return format(currentDate, "'Yesterday at' HH:mm", {
          locale: getLocale(locale)
        })
      }

      if (weekDiff === 1) {
        return format(currentDate, "EEE 'at' HH:mm", {
          locale: getLocale(locale)
        })
      }

      if (weekDiff === -1) {
        return format(currentDate, "'Last' EEE 'at' HH:mm", {
          locale: getLocale(locale)
        })
      }

      return format(currentDate, "dd MMM yyyy 'at' HH:mm", {
        locale: getLocale(locale)
      })
    }
  }
}
